import CaseManagementService from '../services/case-management-service';
import ComplaintService from '../services/complaint-service';

export const complaintTriage = {
  namespaced: true,
  state: {
    information: null,
    triage: null,
    complaint: null,
  },
  actions: {
    getTriage({ commit }, complaintTriageId) {
      commit('setIsBusy', true, { root: true });
      commit('setTriage', null);
      return ComplaintService.getTriage(complaintTriageId)
        .then((triage) => {
          commit('setTriage', triage);
          return triage;
        })
        .finally(() => {
          commit('setIsBusy', false, { root: true });
        });
    },
    reviewMoreInformation(
      { commit },
      { complaintTriageId, complaintTriageMoreInformationId },
    ) {
      commit('setIsBusy', true, { root: true });
      return ComplaintService.reviewMoreInformation(
        complaintTriageId,
        complaintTriageMoreInformationId,
      )
        .then((triage) => {
          commit('setTriage', triage);
          return triage;
        })
        .finally(() => {
          commit('setIsBusy', false, { root: true });
        });
    },
    getByMeasures({ commit }, umrs) {
      commit('setIsBusy', true, { root: true });
      return CaseManagementService.getByMeasures(umrs)
        .then((result) => {
          commit('setInformation', result.model);
          return Promise.resolve(result.model);
        })
        .finally(() => {
          commit('setIsBusy', false, { root: true });
        });
    },
    getByAddress({ commit }, { addressLine1, postcode }) {
      commit('setIsBusy', true, { root: true });
      return CaseManagementService.getByAddress(addressLine1, postcode)
        .then((result) => Promise.resolve(result.model || []))
        .finally(() => {
          commit('setIsBusy', false, { root: true });
        });
    },
    getComplaint({ commit }, complaintNumber) {
      commit('setIsBusy', true, { root: true });
      commit('setComplaint', null);
      return CaseManagementService.getComplaint(complaintNumber)
        .then((result) => {
          commit('setComplaint', result.model);
          return Promise.resolve(result.model);
        })
        .finally(() => {
          commit('setIsBusy', false, { root: true });
        });
    },
    complete({ commit }, { complaintTriageId, completion }) {
      commit('setIsBusy', true, { root: true });
      return ComplaintService.completeTriage(complaintTriageId, completion)
        .then((complaint) => {
          commit('setComplaint', complaint);
          return complaint;
        })
        .finally(() => {
          commit('setIsBusy', false, { root: true });
        });
    },
  },
  mutations: {
    setInformation(state, information) {
      state.information = information;
    },
    setTriage(state, triage) {
      state.triage = triage;
    },
    setComplaint(state, complaint) {
      state.complaint = complaint;
    },
  },
};
